import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import useApiManager from '../../utils/Api/apiManager';

const UsersMultiAutoComplete = ({ selectedUserIds = [], onAssigneesChange, proposalId, small = false, fullWidth = true, disabled = false, role = null }) => {
    const [userOptions, setUserOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const { get, put } = useApiManager();

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const endpoint = role !== null ? `/users/roles/${role}` : '/users';
                const data = await get(endpoint);
                const options = data.map(user => ({
                    label: `${user.firstName} ${user.lastName}`,
                    value: user.id,
                }));

                setUserOptions(options);
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleChange = async (selectedOptions) => {
        const userIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        
        // Update the assignees via API
        if (proposalId) {
            setSaving(true);
            try {
                await put(`/proposals/${proposalId}/assignees`, userIds);
                if (onAssigneesChange) {
                    onAssigneesChange(userIds);
                }
            } catch (error) {
                console.error('Error updating assignees:', error);
            } finally {
                setSaving(false);
            }
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: small ? '40px' : '56px',
            height: small ? 'auto' : 'auto',
            padding: '0px 8px',
            borderRadius: '4px',
            fontSize: '16px',
            borderColor: state.isFocused ? '#1976d2' : provided.borderColor,
            boxShadow: state.isFocused ? '0 0 0 2px rgba(25, 118, 210, 0.2)' : 'none',
            '&:hover': {
                borderColor: '#1976d2',
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
        }),
        input: (provided) => ({
            ...provided,
            fontSize: '16px',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
            color: '#000',
            padding: '8px 12px',
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e3f2fd',
            borderRadius: '4px',
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#1976d2',
            fontSize: '14px',
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#1976d2',
            ':hover': {
                backgroundColor: '#1976d2',
                color: 'white',
            },
        }),
    };

    const selectedValues = userOptions.filter(option => 
        selectedUserIds.includes(option.value)
    );

    return (
        <div style={{ width: fullWidth ? '100%' : 'auto' }}>
            <Select
                isMulti
                isLoading={loading || saving}
                isClearable
                options={userOptions}
                value={selectedValues}
                onChange={handleChange}
                placeholder="Select Assignees"
                styles={customStyles}
                isDisabled={disabled || saving}
                closeMenuOnSelect={false}
            />
        </div>
    );
};

export default UsersMultiAutoComplete;

